import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import CustomArrowUp from "@tSurya/Icons/CustomArrowUp";
import { COLORS } from "@tSurya/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    customArrowUpStyles?: ButtonPresentationProps;
}

export const viewStyles: ProductDetailsViewStyles = {
    leftColumnGridItem: {
        width: [12, 12, 12, 7, 7],
        css: css`
            overflow: visible;
            direction: ltr;
            height: 100%;
            z-index: 1;
            //removed below code due to image top issue.
            position: sticky;
            top: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: auto;
                        position: static;
                    `,
                    css`
                        height: auto;
                        position: static;
                    `,
                    css`
                        height: auto;
                        position: static;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    topGridItem: {
        width: 12,
        css: css`
            padding-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 0px;
                    `,
                    css`
                        padding-bottom: 0px;
                    `,
                    css`
                        padding-bottom: 0px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    middleGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            padding-top: 21px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 21px;
                    `,
                    css`
                        padding-top: 21px;
                    `,
                    css`
                        padding-top: 21px;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    middleGridItemHidden: {
        above: "md",
        css: css`
            width: 100%;
            direction: ltr;
        `,
    },
    bottomGridItem: {
        width: 12,
        css: css`
            display: none;
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            padding-left: 6px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    rightColumnGridItemHidden: {
        below: "lg",
        css: css`
            width: 100%;
            direction: ltr;
        `,
    },
    container: {
        css: css`
            direction: rtl;
            /* overflow: hidden; */
            margin-top: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 17px;
                    `,
                    css`
                        margin-top: 17px;
                    `,
                    css`
                        margin-top: 17px;
                    `,
                    null,
                    null,
                ])}
            > div {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: column-reverse;
                            justify-content: center;
                        `,
                        css`
                            flex-direction: column-reverse;
                            justify-content: center;
                        `,
                        css`
                            flex-direction: column-reverse;
                            justify-content: center;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    customArrowUpStyles: {
        css: css`
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            top: 84%;
            right: 22px;
            background-color: rgb(81 73 81) !important;
            border: rgb(81 73 81) !important;
            z-index: 999;
        `,
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<WidgetProps> = props => {
    const scrollToTopHandler = () => {
        window.scrollTo(0, 50);
    };

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                <Hidden {...styles.rightColumnGridItemHidden}>
                    <Zone contentId={props.id} zoneName="Content3" />
                </Hidden>
            </GridItem>
            <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                <GridContainer {...styles.leftColumnInnerContainer}>
                    <GridItem {...styles.topGridItem}>
                        <Zone contentId={props.id} zoneName="Content0" />
                    </GridItem>
                    <GridItem {...styles.middleGridItem}>
                        <Hidden {...styles.middleGridItemHidden}>
                            <Zone contentId={props.id} zoneName="Content1" />
                        </Hidden>
                    </GridItem>
                    <GridItem {...styles.bottomGridItem}>
                        <Zone contentId={props.id} zoneName="Content2" />
                    </GridItem>
                </GridContainer>
                <Hidden below="md">
                    <Button {...styles.customArrowUpStyles} onClick={scrollToTopHandler}>
                        <Icon src={CustomArrowUp}> </Icon>
                    </Button>
                </Hidden>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
